// extracted by mini-css-extract-plugin
export var leftAlign = "_1x-2";
export var popper = "_1x-0";
export var subtitle = "_1x-1";